import React from 'react';

import { TextInput as UswdsTextInput, Label } from '@trussworks/react-uswds';

import classnames from 'classnames';
import Tooltip from '@components/tooltip/tooltip';

import './TextInput.scss';

interface TextInputProps {
  label: string;
  name: string;
  onChange: ({
    e,
    value,
    onChangeProps,
  }: {
    e: React.ChangeEvent<HTMLInputElement>;
    value: string | number;
    onChangeProps?: Record<string, unknown>;
  }) => void;
  type: 'text' | 'number' | 'email' | 'password' | 'tel' | 'url' | 'search';

  className?: string;
  defaultValue?: string | number;
  hasError?: boolean;
  isReadOnly?: boolean;
  isRequired?: boolean;
  isValid?: boolean;
  maxLength?: number;
  maxValue?: string | number;
  minValue?: string | number;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChangeProps?: Record<string, unknown>;
  showOptionalText?: boolean;
  tooltipContent?: React.ReactNode;
  value?: string | number;
}

const TextInput: React.FC<TextInputProps> = ({
  className = 'width-full',
  defaultValue,
  hasError,
  isReadOnly,
  isRequired,
  isValid,
  label,
  maxLength,
  maxValue,
  minValue,
  name,
  onBlur = () => {},
  onChange,
  onChangeProps = {},
  showOptionalText = true,
  tooltipContent,
  type,
  value,
}) => {
  const labelStyles = classnames({
    required: isRequired,
    optional: !isRequired && showOptionalText,
  });
  const maxValAttr = type === 'number' && maxValue ? Number(maxValue) : undefined;
  const maxLenAttr = type === 'text' ? 256 : maxLength || undefined;
  const minValAttr = type === 'number' && minValue ? Number(minValue) : undefined;

  return (
    <>
      {typeof label === 'string' && (
        <Label className={labelStyles} htmlFor={name}>
          <span id={`${name}_label`}>{label}</span>
          {tooltipContent && <Tooltip content={tooltipContent} header={label} name={name} />}
        </Label>
      )}
      <UswdsTextInput
        aria-invalid={hasError ? 'true' : 'false'}
        aria-required={isRequired ? 'true' : 'false'}
        className={className}
        id={name}
        key={name}
        max={maxValAttr}
        maxLength={maxLenAttr}
        min={minValAttr}
        name={name}
        onBlur={onBlur}
        onChange={(e) => onChange({ e, value: e.target.value, onChangeProps })}
        readOnly={isReadOnly}
        required={isRequired}
        type={type}
        defaultValue={defaultValue}
        validationStatus={isValid === false ? 'error' : undefined}
        value={value}
      />
    </>
  );
};

export default TextInput;
